module.exports = __webpack_public_path__ + "static/media/wave_gray_down.0d0fe7a1.svg";